export default function guest(nav) {
  let user = localStorage.getItem("user");
  console.log(window.location.href);
  if (window.location.href.includes("access_token")) {
    localStorage.removeItem("user");
    localStorage.removeItem("userName");
    localStorage.removeItem("userAvatar");
    localStorage.removeItem("token");
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("access_token");
    localStorage.setItem("token", "Bearer " + token);
    return (window.location.href = "/home");
  } else {
    if (localStorage.getItem("token") !== null) {
      if (user !== null && JSON.parse(user).is_registered_compelete === 0) {
        return (window.location.href = "/sign-up");
      } else {
        return (window.location.href = "/home");
      }
    }
  }
  return nav.next();
}
